import { render, staticRenderFns } from "./ExpensesMaterialVariantHistory.vue?vue&type=template&id=4c59f7ea&scoped=true"
import script from "./ExpensesMaterialVariantHistory.vue?vue&type=script&lang=js"
export * from "./ExpensesMaterialVariantHistory.vue?vue&type=script&lang=js"
import style0 from "./ExpensesMaterialVariantHistory.vue?vue&type=style&index=0&id=4c59f7ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c59f7ea",
  null
  
)

export default component.exports